import { Filters } from '../../utils/enums';

export const supportedFilters = [
  Filters.Spend,
  Filters.Campaigns,
  Filters.Countries,
  Filters.ExcludedTag,
];
